import styled from "styled-components";

interface FivePrayerProps {
    readonly $rgba_odd_bg: { r: number; g: number; b: number; a: number };
    readonly $rgba_even_bg: { r: number; g: number; b: number; a: number };
    readonly $rgba_odd_text: { r: number; g: number; b: number; a: number };
    readonly $rgba_even_text: { r: number; g: number; b: number; a: number };
    readonly $rgba_border_clr?: { r: number; g: number; b: number; a: number };
    readonly $rgba_border_size?: number;
    readonly $rgba_border_style?: string;
    readonly $rgba_light_bg?: { r: number; g: number; b: number; a: number };
    readonly $rgba_light_text?: { r: number; g: number; b: number; a: number };
}

export const PrayerTableStyled = styled.div.attrs<FivePrayerProps>((p) => ({
    style: {
        ...p.style,
        '--sc-color-odd': `rgba(${p.$rgba_odd_bg.r},${p.$rgba_odd_bg.g},${p.$rgba_odd_bg.b},${p.$rgba_odd_bg.a})`,
        '--sc-color-even': `rgba(${p.$rgba_even_bg.r},${p.$rgba_even_bg.g},${p.$rgba_even_bg.b},${p.$rgba_even_bg.a})`,
        '--sc-color-odd-text': `rgba(${p.$rgba_odd_text.r},${p.$rgba_odd_text.g},${p.$rgba_odd_text.b},${p.$rgba_odd_text.a})`,
        '--sc-color-even-text': `rgba(${p.$rgba_even_text.r},${p.$rgba_even_text.g},${p.$rgba_even_text.b},${p.$rgba_even_text.a})`,
        '--sc-border': p.$rgba_border_clr ? `${p.$rgba_border_style || 'solid'} ${p.$rgba_border_size || 1}px rgba(${p.$rgba_border_clr.r},${p.$rgba_border_clr.g},${p.$rgba_border_clr.b},${p.$rgba_border_clr.a})` : 'none',
        '--sc-highlight-bg': p.$rgba_light_bg ? `rgba(${p.$rgba_light_bg.r},${p.$rgba_light_bg.g},${p.$rgba_light_bg.b},${p.$rgba_light_bg.a})` : 'transparent',
        '--sc-highlight-text': p.$rgba_light_text ? `rgba(${p.$rgba_light_text.r},${p.$rgba_light_text.g},${p.$rgba_light_text.b},${p.$rgba_light_text.a})` : 'inherit'
    },
}))`
    table {
        border-collapse: collapse;
        width: 100%;
        border: var(--sc-border);
    }

    th, td {
        border: var(--sc-border);
        text-align: center;
        padding: 8px;
    }

    tr:nth-child(odd) {
        background-color: var(--sc-color-odd);
        color: var(--sc-color-odd-text);
    }
    
    tr:nth-child(even) {
        background-color: var(--sc-color-even);
        color: var(--sc-color-even-text);
    }
    
    tr.demo-table-highlight {
        background-color: var(--sc-highlight-bg) !important;
        color: var(--sc-highlight-text) !important;
    }
`;